import { render, staticRenderFns } from "./logout_icon.vue?vue&type=template&id=748a841a&scoped=true"
import script from "./logout_icon.vue?vue&type=script&lang=js"
export * from "./logout_icon.vue?vue&type=script&lang=js"
import style0 from "./logout_icon.vue?vue&type=style&index=0&id=748a841a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748a841a",
  null
  
)

export default component.exports